import BackButton from "components/Button/BackButton"
import DeleteButton from "components/Button/DeleteButton"
import SaveButton from "components/Button/SaveButton"
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { ApiResponseStatusUnauthorized, ApiResponseSuccess, EmptyString, FormTypeAdd, FormTypeEdit } from "utils/Constant"
import { ApiDeleteCustomer, ApiGetCustomer, ApiInsertCustomer, ApiUpdateCustomer } from "utils/constants/api"
import useFetch from "utils/hooks/useFetch"
import FailModal from "components/modal/FailModal";
import LoadingModal from "components/modal/LoadingModal";
import SuccessModal from "components/modal/SuccessModal";
import ConfirmationModal from "components/modal/ConfirmationModal";

export default function CustomerCardForm(){
    const navigate = useNavigate()

    const { fetch: insertCustomer } = useFetch(ApiInsertCustomer)
    const { fetch: updateCustomer } = useFetch(ApiUpdateCustomer)
    const { fetch: deleteCustomer } = useFetch(ApiDeleteCustomer)
    const { fetch: getCustomer } = useFetch(ApiGetCustomer)

    let queryString = new URLSearchParams(window.location.search)
    let formType = queryString.get("formType")
    let paramCustomerId = queryString.get("customerId")

    const [customerName, setCustomerName] = useState(EmptyString)
    const [address, setAddress] = useState(EmptyString)
    const [phone, setPhone] = useState(EmptyString)

    // Modal
    const [failModal, setFailModal] = useState({ isOpen: false, data: {}, message: EmptyString })
    const [loading, setLoading] = useState(false)
    const [successModal, setSuccessModal] = useState({ isOpen: false, data: {} })
    const [confirmationModal, setConfirmationModal] = useState({ isOpen: false, data: {} })

    // Error
    const [errorTenantId, setErrorTenantId] = useState(false)
    const [errorCustomerName, setErrorCustomerName] = useState(false)
    const [errorPhone, setErrorPhone] = useState(false)

    useEffect(() => {
        if (formType === FormTypeEdit){
            setLoading(true)

            fGetCustomer().then(() => {
                setLoading(false)
            })
        }
    }, [])


    // Function Api Call
    async function fInsertCustomer(){
        await insertCustomer({
            data:{
                customerName: customerName,
                address: address, 
                phone: phone,
                updateId: localStorage.getItem("Id")
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setSuccessModal({ isOpen: true, data: { onSuccess: async () => { navigate("/location/customer") }} })
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    async function fUpdateCustomer(){
        await updateCustomer({
            data:{
                customerId: paramCustomerId,
                customerName: customerName,
                address: address,
                phone: phone,
                updateId: localStorage.getItem("Id")
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setSuccessModal({ isOpen: true, data: { onSuccess: async () => { navigate("/location/customer") }} })
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        }).finally(() => {
            setLoading(false)
        })
    }
    async function fDeleteCustomer(){
        await deleteCustomer({
            data:{
                customerId: paramCustomerId,
                updateId: localStorage.getItem("Id")
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setSuccessModal({ isOpen: true, data: { onSuccess: async () => { navigate("/location/customer") }} })
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    async function fGetCustomer(){
        await getCustomer({
            data: {
                customerId: paramCustomerId
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                let data = response.data

                setCustomerName(data.customerName)
                setAddress(data.address)
                setPhone(data.phone)
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }

    // Function

    function fSaveBtnClick(){
        setConfirmationModal({ isOpen: true, data: { onSuccess: async () => { 
            setConfirmationModal({ isOpen: false })
            setLoading(true)

            if (formType === FormTypeAdd){
                fInsertCustomer().then(() => {
                    setLoading(false)
                })
            }else{
                fUpdateCustomer().then(() => {
                    setLoading(false)
                })
            }
        }}})
    }
    function fDeleteBtnClick(){
        setConfirmationModal({ isOpen: true, data: { onSuccess: async () => { 
            setConfirmationModal({ isOpen: false })
            setLoading(true)

            fDeleteCustomer().then(() => {
                setLoading(false)
            })
        }}})
    }

    return (
        <div className="flex flex-col gap-2">
            <div>
                <span className="font-semibold text-2xl">Customer Detail</span>
            </div>
            <hr />

            <div className="mt-5 flex flex-col gap-3">
                {/* Customer Name */}
                <div>
                    <div className="flex">
                        <div className="flex flex-col sm:flex-row sm:items-center w-full">
                            <div className="w-48">
                                <span>Customer Name</span>
                            </div>
                            <div className="px-4 hidden sm:block">
                                <span>:</span>
                            </div>
                            <div className="w-full sm:w-72">
                                <input className="input" value={ customerName } onChange={(e) => { setCustomerName(e.target.value) }} />
                            </div>
                        </div>
                    </div>
                    <div className={`flex items-center ${ errorCustomerName ? 'block' : 'hidden' }`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Customer Name is required!</span>
                    </div>
                </div>

                {/* Address */}
                <div>
                    <div className="flex">
                        <div className="flex flex-col sm:flex-row sm:items-center w-full">
                            <div className="w-48">
                                <span>Address</span>
                            </div>
                            <div className="px-4 hidden sm:block">
                                <span>:</span>
                            </div>
                            <div className="w-full sm:w-72">
                                <input className="input" value={ address } onChange={(e) => { setAddress(e.target.value) }} maxLength={100} />
                            </div>
                        </div>
                    </div>
                    <div className={`flex items-center ${ errorTenantId ? 'block' : 'hidden' }`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Call Center is required!</span>
                    </div>
                </div>

                {/* Phone */}
                <div>
                    <div className="flex">
                        <div className="flex flex-col sm:flex-row sm:items-center w-full">
                            <div className="w-48">
                                <span>Phone</span>
                            </div>
                            <div className="px-4 hidden sm:block">
                                <span>:</span>
                            </div>
                            <div className="w-full sm:w-72">
                                <input className="input" value={ phone } onChange={(e) => { setPhone(e.target.value) }} maxLength={20} />
                            </div>
                        </div>
                    </div>
                    <div className={`flex items-center ${ errorPhone ? 'block' : 'hidden' }`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Phone is required!</span>
                    </div>
                </div>

            </div>
                

            <div className="mt-5 flex flex-wrap justify-end w-full gap-2">
                <SaveButton onClick={() => { fSaveBtnClick() }} visible={true} />
                <DeleteButton visible={ formType === FormTypeAdd ? false : true } onClick={() => { fDeleteBtnClick() }} />
                <BackButton onClick={() => { navigate("/location/customer") }}  />
            </div>

             {/* Modal */}
 			{failModal.isOpen && ( <FailModal onClose={() => setFailModal({ isOpen: false, data: {}, message: EmptyString })} data={failModal?.data} message={failModal?.message} /> )}
 			{loading ? (<LoadingModal />) : (<div />)}
            {successModal.isOpen && ( <SuccessModal onClose={() => setSuccessModal({ isOpen: false, data: {} })} data={successModal?.data} /> )}
            {confirmationModal.isOpen && ( <ConfirmationModal onClose={() => setConfirmationModal({ isOpen: false, data: {} })} data={confirmationModal?.data} /> )}
        </div>
    )
}